"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var internal_1 = require("../../shared/internal");
var logFormat_1 = require("./logFormat");
var shared_1 = require("@cian/system-logger/shared");
var browser_1 = require("@cian/config/browser");
var BrowserLogger = /** @class */ (function () {
    function BrowserLogger(opts) {
        this.messageWriter = opts.messageWriter;
        this.errorWriter = opts.errorWriter;
        this.context = opts.context;
    }
    BrowserLogger.prototype.debug = function (message, meta) {
        if (browser_1.getConfig().get('logger.browser.debug')) {
            this.messageWriter.write(__assign(__assign({}, logFormat_1.formatAppLog(this.context)), internal_1.formatMessageLog('debug', message, meta)));
        }
    };
    BrowserLogger.prototype.info = function (message, meta) {
        this.messageWriter.write(__assign(__assign({}, logFormat_1.formatAppLog(this.context)), internal_1.formatMessageLog('info', message, meta)));
    };
    BrowserLogger.prototype.warning = function (message, meta) {
        this.messageWriter.write(__assign(__assign({}, logFormat_1.formatAppLog(this.context)), internal_1.formatMessageLog('warning', message, meta)));
    };
    BrowserLogger.prototype.error = function (error, meta) {
        this.errorWriter.write(__assign(__assign({}, logFormat_1.formatAppLog(this.context)), shared_1.formatErrorLog(error, 'error', meta)));
    };
    return BrowserLogger;
}());
exports.BrowserLogger = BrowserLogger;
//# sourceMappingURL=browserLogger.js.map